export default __webpack_public_path__ + "static/media/delete.c75b3ac6.svg";